<template>
  <v-data-table
    :headers="headers"
    :items="historicoITCDF"
    :items-per-page="15"
    class="elevation-1"
    :sort-by="['ano', 'mes']"
    :sort-desc="['true', 'true']"
    :footer-props="{
      itemsPerPageAllText: 'Todos',
      itemsPerPageText: 'Itens por página'
    }"
  ></v-data-table>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      headers: [
        { text: "Mês", value: "mes" },
        { text: "Ano", value: "ano" },
        { text: "Valor", value: "valor", sortable: false }
      ],
      historicoITCDF: []
    };
  },
  mounted() {
    axios
      .get("/itcdf")
      .then(
        resposta =>
          (this.historicoITCDF = JSON.parse(resposta.data.historicoITCDF))
      )
      .catch(error => console.log(error));
  }
};
</script>

<style lang="scss" scoped></style>
